import { keepPreviousData, useQuery, type QueryClient } from '@tanstack/react-query';
import { api } from '@/lib/axios';

export interface UniqueStatusRow {
  id: number;
  uniqueName: string;
  charName128: string;
  status: 'Alive' | 'Dead';
  map: string;
  lastUpdate: string;
}

export const UNIQUES_STATUS_QUERY_KEY = ['uniques', 'status'] as const;

export interface UniqueDeathRow {
  id: number;
  uniqueName: string;
  charName128: string;
  map: string;
  eventAt: string;
}

export function useUniqueDeaths() {
  return useQuery({
    queryKey: ['uniques', 'deaths'],
    staleTime: 30_000,
    queryFn: async () => {
      const { data } = await api.get<{ data: { logs: UniqueDeathRow[] } }>('/api/v1/uniques/logs');
      return data.data.logs;
    },
  });
}

export async function fetchUniqueStatus(): Promise<UniqueStatusRow[]> {
  const { data } = await api.get<{ status: string; data: { uniques: UniqueStatusRow[] } }>(
    '/api/v1/uniques/status',
  );
  return data.data?.uniques ?? [];
}

export function useUniqueStatus() {
  return useQuery({
    queryKey: UNIQUES_STATUS_QUERY_KEY,
    queryFn: fetchUniqueStatus,
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });
}

export function prefetchUniquesQueries(queryClient: QueryClient): void {
  void queryClient.prefetchQuery({
    queryKey: UNIQUES_STATUS_QUERY_KEY,
    queryFn: fetchUniqueStatus,
    staleTime: 30_000,
  });
}
